'use client'

import { NotesIcon } from '@repo/ui/NotesIcon'
import { useClientStore } from '@repo/store/useClientStore'
import { useMattersStore } from '@repo/store/useMattersStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import MUIBadge from '@mui/material/Badge'
import MUIIconButton from '@mui/material/IconButton'
import MUITooltip from '@mui/material/Tooltip'
import PropTypes from 'prop-types'

export const NotesButton = ({ level = 'Matter', sx = {} }) => {
  const { matterNotesIsOpen, matterNotes, currentClientMatterNo } = useMattersStore()
  const { allowedActions } = useMenuItemsStore()
  const allowViewNotes = allowedActions?.viewNotes?.allowed || false
  const { currentClientNo } = useClientStore()

  let notesForThisEntity = null

  if (level === 'Matter') {
    notesForThisEntity = matterNotes && currentClientMatterNo ? matterNotes[currentClientMatterNo] : null
  } else {
    notesForThisEntity = matterNotes && currentClientNo ? matterNotes[`${currentClientNo}-0`] : null
  }

  const notesCount = notesForThisEntity?.length > 9 ? '9+' : notesForThisEntity?.length || 0

  const handleClick = () => {
    useMattersStore.setState({ matterNotesIsOpen: !matterNotesIsOpen })
  }

  if ((level === 'Matter' && !currentClientMatterNo) || (level === 'Client' && !currentClientNo) || !allowViewNotes)
    return <div data-testid="NotesButton" />

  return (
    <>
      <MUITooltip title={`${level} notes`} arrow placement="top">
        <MUIIconButton
          data-testid="NotesButton"
          onClick={handleClick}
          sx={{
            backgroundColor: 'white',
            border: '1px, solid #D8DCE5',
            width: '42px',
            height: '42px',
            padding: '10px',
            position: 'relative',
            ...sx
          }}
        >
          {notesCount ? (
            <MUIBadge
              badgeContent={notesCount}
              color="secondary"
              sx={{
                position: 'absolute',
                top: '8px',
                right: '4px',
                [`.MuiBadge-badge`]: { width: '1rem', height: '20px', fontSize: '0.75rem' }
              }}
            ></MUIBadge>
          ) : null}
          <NotesIcon sx={{ color: '#3D517B', height: '1.25rem', width: '1.25rem' }} />
        </MUIIconButton>
      </MUITooltip>
    </>
  )
}

NotesButton.propTypes = {
  level: PropTypes.string,
  sx: PropTypes.object
}
